const cnProductMatch = {
    displayName: 'CNProductMatch'
};

export default cnProductMatch;